import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';

/**
 * Local Devices module.
 *
 * Owns no routes of its own: `/processor/local-devices` is declared in
 * `main.tsx` behind `ModuleProtectedRoute`. This registration is what lets the
 * registry answer for it — the route guard and the nav's `requiredModule` both
 * ask the registry, which answers FALSE for a module that was never registered.
 */
class LocalDevicesModuleClass extends BaseModule {
  id = 'LOCAL_DEVICES';
  name = 'Local Devices';
  label = 'Local Devices';
  description =
    'Pair Farmshare Desktop stations and manage their printers, scales and screens';
  version = '1.0.0';

  createRoutes = (): RouteObject[] => [];
}

export const LocalDevicesModule = new LocalDevicesModuleClass();
